<template>
	<div class="grid-content">
		<div class="grid-content-title">
			<div class="name">司机管理</div>
			<div class="right">
				<el-button size="mini" @click="refreshDriver">
					<i class="el-icon-refresh"></i>
					<span>刷新</span>
				</el-button>
			</div>
		</div>
		<div class="grid-content-search">
			<div class="line">
				<el-row :gutter="20">
					<el-col :span="9">
						<div class="box">
							<div class="label">司机查询：</div>
							<div class="input">
								<el-input v-model="query.keyword" placeholder="请输入关键字" class="input-with-select"
									size="small" clearable>
									<el-select v-model="query.type" slot="prepend" placeholder="请选择">
										<el-option label="按姓名" value="name"></el-option>
										<el-option label="按手机号" value="phone"></el-option>
									</el-select>
								</el-input>
							</div>
						</div>
					</el-col>
					<el-col :span="15">
						<el-button type="primary" icon="el-icon-search" size="small" style="width: 6rem;"
							@click="searchDriver">搜索</el-button>
						<el-button size="small" @click="resetSearchDriver">重置</el-button>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="grid-content-operate">
			<el-button type="primary" size="small" @click="addDriver">添加司机</el-button>
			<el-button :disabled="coin_disabled" @click="coinDriver" size="small">
				<i class="el-icon-coin"></i>
				<span>增减财务</span>
			</el-button>
		</div>
		<div class="grid-content-list driver">
			<div class="common-table">
				<table class="header">
					<colgroup>
						<col width="4%">
						<col width="15%">
						<col width="12%">
						<col width="8%">
						<col width="8%">
						<col width="8%">
						<col width="12%">
						<col width="8%">
						<col width="8%">
						<col>
					</colgroup>
					<thead>
						<tr>
							<th>
								<el-checkbox></el-checkbox>
							</th>
							<th>司机</th>
							<th>余额</th>
							<th>总接单</th>
							<th>驾龄</th>
							<th>评分</th>
							<th>今日时长</th>
							<th>上下线</th>
							<th>合作</th>
							<th>操作</th>
						</tr>
					</thead>
				</table>
				<table class="body" v-loading="(loading && total>0)?true:false">
					<colgroup>
						<col width="4%">
						<col width="15%">
						<col width="12%">
						<col width="8%">
						<col width="8%">
						<col width="8%">
						<col width="12%">
						<col width="8%">
						<col width="8%">
						<col>
					</colgroup>
					<thead>
						<template v-for="(item,index) in list">
							<tr class="separation-row">
								<td colspan="10"></td>
							</tr>
							<tr class="content-row">
								<td>
									<div style="display: flex;align-items: center;justify-content: center;">
										<el-checkbox v-model="item.checked" @change="checkboxDriver"></el-checkbox>
									</div>
								</td>
								<td>
									<div class="user">
										<img v-if="item.rhead" class="avatar" :src="item.rhead" />
										<img v-else class="avatar" src="../../assets/custom_head.png" />
										<div class="info">
											<div class="name">
												<span>{{item.rname}}</span>
												<el-tooltip v-if="item.admin" effect="dark" content="APP端管理员"
													placement="top">
													<img class="admin" src="../../assets/driver_admin.png" />
												</el-tooltip>
											</div>
											<div class="phone">{{item.phone}}</div>
										</div>
										<div class="take" :class="(item.take>0)?'o1':''">
											<div class="bg"></div>
											<div v-if="item.take>0" class="text">日结</div>
											<div v-else class="text">单结</div>
										</div>
									</div>
								</td>
								<td>
									<div class="amount">
										<div class="box">
											<div class="num link" @click="amountDriver(item.id)">{{item.amount}}
											</div>
											<div class="unit">元</div>
										</div>
									</div>
									<div v-if="item.take>0" class="takes">
										<span>按日扣</span>
										<span style="font-weight: bold;color: red;">{{item.takes}}</span>
										<span>元</span>
										<el-tooltip effect="dark" :content="'每天系统会自动扣除'+item.takes+'元'" placement="top">
											<i class="el-icon-question"></i>
										</el-tooltip>
									</div>
								</td>
								<td>
									<div class="order">
										<div class="box">
											<div class="num link" @click="orderDriver(item.rname)">{{item.dd}}</div>
											<div class="unit">单</div>
										</div>
									</div>
								</td>
								<td>
									<div class="dage">{{item.dage}}</div>
								</td>
								<td>
									<div class="score">
										<div class="box">
											<div class="num link" style="color: #f60;" @click="commentDriver(item.rname)">{{item.score}}
											</div>
											<div class="unit">分</div>
										</div>
									</div>
								</td>
								<td>
									<div class="online">
										<div class="box">
											<div>00小时00分钟</div>
											<div class="log link">记录</div>
										</div>
									</div>
								</td>
								<td>
									<div class="job">
										<el-switch v-model="item.job" :active-value="1" :inactive-value="0"
											active-color="#13ce66" :disabled="!item.job"
											@change="jobDriver($event, index)">
										</el-switch>
									</div>
								</td>
								<td>
									<div class="coope">
										<el-switch v-model="item.coope" :active-value="1" :inactive-value="0"
											active-color="#13ce66" :disabled="(item.del>0)?true:false"
											@change="coopeDriver($event, index)">
										</el-switch>
									</div>
								</td>
								<td>
									<div class="operate">
										<div v-if="item.del>0" class="link" style="font-size: 0.875rem;"
											@click="delDriver(index, 0)">恢复停用</div>
										<template v-else>
											<el-button plain size="mini" @click="editDriver(index)">编辑
											</el-button>
											<el-button type="danger" plain size="mini" @click="delDriver(index, 1)">
												停用
											</el-button>
										</template>
									</div>
								</td>
							</tr>
						</template>
					</thead>
				</table>
			</div>
			<div v-if="loading && total<=0" style="min-height: 20rem;" v-loading="loading"></div>
			<div v-if="total>0" class="page">
				<el-pagination background layout="total, prev, pager, next" :current-page.sync="page" :total="total"
					@current-change="pageDriver">
				</el-pagination>
			</div>
			<el-empty v-if="!loading && total<=0" style="height: 20rem;" description="暂无司机数据" :image-size="100">
			</el-empty>
		</div>
		<el-drawer :title="info.form.mode=='edit'?'编辑司机':'添加司机'" :visible.sync="info.show">
			<div class="drawer driver">
				<el-alert v-if="info.form.mode=='edit'" title="任何修改，都需要经过保存才能生效" type="warning" show-icon
					:closable="false">
				</el-alert>
				<div class="content">
					<el-form :model="info.form" :rules="info.rules" label-position="left" label-width="100px"
						ref="driverInfoForm" size="small" style="margin-top: 1.25rem;">
						<el-form-item label="头像">
							<div v-if="info.form.head" class="avatar y">
								<el-avatar shape="square" :size="100" :src="info.form.head"></el-avatar>
								<i class="close el-icon-error" @click="info.form.head = ''"></i>
							</div>
							<el-upload v-else class="avatar u" action="" :on-change='cropperImageDriver'
								:auto-upload="false" :show-file-list="false">
								<i class="el-icon-camera avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
						<el-form-item label="真实姓名" prop="name">
							<el-input v-model="info.form.name" style="width: 8.125rem;" clearable>
							</el-input>
						</el-form-item>
						<el-form-item label="手机号码" prop="phone">
							<el-input v-model="info.form.phone" style="width: 11rem;" clearable>
							</el-input>
						</el-form-item>
						<el-form-item label="身份证号" prop="cardid">
							<el-input v-model="info.form.cardid" clearable></el-input>
						</el-form-item>
						<el-form-item label="领证时间" prop="carddate">
							<el-date-picker v-model="info.form.carddate" type="date" placeholder="选择日期"
								value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
						<el-form-item label="合作方式">
							<el-radio-group v-model="info.form.take">
								<el-radio-button :label="0">按单结</el-radio-button>
								<el-radio-button :label="1">按日结</el-radio-button>
							</el-radio-group>
						</el-form-item>
						<el-form-item v-if="info.form.take==1" label="收取金额" prop="out_amount">
							<div style="display: inline-block; width: 7rem;">
								<el-input-number v-model.number="info.form.takes" style="width: 100%;"
									controls-position="right" :min="0" :max="999" :precision="2">
								</el-input-number>
							</div>
							<div style="display: inline-block;font-size: 0.75rem;margin-left: 0.3125rem;color: #999;">
								每天系统自动扣除
							</div>
						</el-form-item>
						<el-form-item label="APP权限">
							<el-switch v-model.number="info.form.admin" :active-value="1" :inactive-value="0">
							</el-switch>
						</el-form-item>
					</el-form>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" :loading="info.loading" @click="submitInfoDriver">
						{{info.form.mode == "edit"?"提交保存":"确认添加"}}
					</el-button>
				</div>
			</div>
		</el-drawer>
		<el-dialog title="头像裁切" :visible.sync="dialog_cropper.show" append-to-body>
			<div class="cropper-content">
				<div class="cropper" style="text-align:center">
					<vueCropper ref="cropper" :info="true" :img="dialog_cropper.image"
						:outputSize="dialog_cropper.outputSize" :outputType="dialog_cropper.outputType"
						:autoCrop="dialog_cropper.autoCrop" :autoCropWidth="dialog_cropper.autoCropWidth"
						:autoCropHeight="dialog_cropper.autoCropHeight" :fixed="dialog_cropper.fixed"
						:fixedNumber="dialog_cropper.fixedNumber" :fixedBox="dialog_cropper.fixedBox"
						:canMoveBox="false" :centerBox="true" :original="false" :infoTrue="false" :full="false" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialog_cropper.show = false">取消</el-button>
				<el-button type="primary" size="small" @click="submitCropperImageDriver">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="增减财务" :visible.sync="coin.show" width="30%" append-to-body>
			<el-form :model="coin.form" size="small">
				<el-form-item label="司机" label-width="60px">
					<span style="font-size: 0.875rem;color: #576b95;">{{coin.form.name}}</span>
				</el-form-item>
				<el-form-item label="类型" label-width="60px">
					<el-radio-group v-model="coin.form.type">
						<el-radio-button label="增加"></el-radio-button>
						<el-radio-button label="减少"></el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="金额" label-width="60px">
					<el-input-number v-model.number="coin.form.amount" controls-position="right" :min="1" :max="9999"
						:precision="2" :style="{'width':'150px'}">
					</el-input-number>
				</el-form-item>
				<el-form-item label="说明" label-width="60px">
					<el-input v-model="coin.form.desc" type="textarea" placeholder="请输入金额备注，可为空">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="coin.show = false">取消</el-button>
				<el-button type="primary" size="small" :loading="coin.loading" @click="submitCoinDriver">确定
				</el-button>
			</div>
		</el-dialog>
		<!-- 		<el-dialog title="账号停用" :visible.sync="dialog_del.show" width="30%" append-to-body>
			<div class="dialog del">
				<el-alert style="margin-bottom: 0.625rem;" title="账号停用后，该司机则在期限内无法登录司机端" type="warning" show-icon
					:closable="false">
				</el-alert>
				<el-form :model="dialog_del.form" size="small">
					<el-form-item label="司机" label-width="60px">
						<span style="font-size: 0.875rem;color: #576b95;">{{dialog_del.form.name}}</span>
					</el-form-item>
					<el-form-item label="期限" label-width="60px">
						<el-date-picker v-model="dialog_del.form.date" type="date" placeholder="选择日期">
						</el-date-picker>
						<div class="quick">
							<span @click="quickDelDriver(1)">7天</span>
							<span @click="quickDelDriver(2)">15天</span>
							<span @click="quickDelDriver(3)">30天</span>
							<span @click="quickDelDriver(4)">长期</span>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialog_del.show = false">取消</el-button>
				<el-button type="primary" size="small" :loading="dialog_del.loading" @click="submitDelDriver(1)">确定
				</el-button>
			</div>
		</el-dialog> -->
		<el-dialog title="余额明细" :visible.sync="dialog_amount.show" width="60%">
			<div v-if="dialog_amount.loading && dialog_amount.total<=0" style="min-height: 20rem;"
				v-loading="dialog_amount.loading"></div>
			<template v-else>
				<el-table :data="dialog_amount.list" border style="width: 100%" size="small"
					v-loading="(dialog_amount.loading && dialog_amount.total>0)?true:false">
					<el-table-column type="selection" align="center" width="55"></el-table-column>
					<el-table-column align="center" width="90" label="类型">
						<template slot-scope="scope">
							<span v-if="scope.row.type=='增加'" style="color: #07c160;">{{ scope.row.type }}</span>
							<span v-else style="color: red;">{{ scope.row.type }}</span>
						</template>
					</el-table-column>
					<el-table-column label="说明">
						<template slot-scope="scope">
							{{ scope.row.text }}
						</template>
					</el-table-column>
					<el-table-column align="center" width="110" label="变更前">
						<template slot-scope="scope">
							{{ scope.row.change_prev }}
						</template>
					</el-table-column>
					<el-table-column align="center" width="110" label="变更后">
						<template slot-scope="scope">
							{{ scope.row.change_next }}
						</template>
					</el-table-column>
					<el-table-column align="center" width="165" label="时间">
						<template slot-scope="scope">
							{{ scope.row.time }}
						</template>
					</el-table-column>
				</el-table>
				<div slot="footer" class="dialog-footer">
					<el-pagination layout="total, prev, pager, next" :total="dialog_amount.total"
						@current-change="pageAmountDriver">
					</el-pagination>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				query: {},
				page: 1,
				total: 0,
				list: [],
				coin_disabled: true,
				coin: {
					show: false,
					loading: false,
					form: {
						type: '增加',
						name: '',
						amount: '',
						desc: ''
					},
				},
				info: {
					show: false,
					loading: false,
					rules: {
						name: [{
								required: true,
								message: '请输入司机真实姓名'
							},
							{
								validator(rule, value, callback) {
									const reg = /^[\u4e00-\u9fa5]+$/
									if (value.length < 100 && reg.test(value)) {
										callback()
									} else {
										return callback(new Error('请输入正确的司机姓名'))
									}
								},
								trigger: 'blur'
							}
						],
						phone: [{
								required: true,
								message: '请输入手机号码'
							},
							{
								validator(rule, value, callback) {
									const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
									if (reg.test(value)) {
										callback()
									} else {
										return callback(new Error('请输入正确的手机号码'))
									}
								},
								trigger: 'blur'
							}
						],
						cardid: [{
								required: true,
								message: '请输入身份证号码'
							},
							{
								validator(rule, value, callback) {
									const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
									if (reg.test(value)) {
										callback()
									} else {
										return callback(new Error('请输入正确的身份证号'))
									}
								},
								trigger: 'blur'
							}
						],
						carddate: [{
							required: true,
							message: '请选择驾驶证领证日期',
							trigger: 'blur'
						}]
					},
					form: {
						mode: "add",
						id: 0,
						head: "",
						name: "",
						phone: "",
						cardid: "",
						carddate: "",
						take: 0,
						takes: 0,
						admin: 0
					}
				},
				dialog_cropper: {
					show: false,
					image: '',
					outputSize: 0.8, // 裁剪生成图片的质量
					outputType: 'jpeg', // 裁剪生成图片的格式
					autoCrop: true, // 是否默认生成截图框
					autoCropWidth: 200, //默认生成截图框宽度
					autoCropHeight: 200, //默认生成截图框高度
					fixedBox: true, // 固定截图框大小 不允许改变
					fixed: false, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1] // 截图框的宽高比例
				},
				dialog_amount: {
					show: false,
					loading: true,
					driver: 0,
					page: 1,
					total: 0,
					list: []
				}
			};
		},
		created() {
			this.postDriver();
		},
		methods: {
			checkboxDriver() {
				const that = this;
				const list = that.list;
				that.coin_disabled = true;
				for (var i = 0; i < list.length; i++) {
					if (list[i].checked) {
						that.coin_disabled = false;
						break;
					}
				}
			},
			searchDriver() {
				const that = this;
				if (that.query.type != undefined && that.query.keyword != undefined) {
					that.pageDriver(1);
				}
			},
			resetSearchDriver(){
				this.query = {};
				this.pageDriver(1);
			},
			coinDriver() {
				const that = this;
				const list = that.list;
				var rname = [];
				for (var i = 0; i < list.length; i++) {
					if (list[i].checked) {
						rname.push(list[i].rname);
					}
				}
				that.coin = that.$options.data().coin;
				that.coin.show = true;
				that.coin.loading = false;
				that.coin.form.type = "增加";
				that.coin.form.name = rname.join("、");
			},
			submitCoinDriver() {
				const that = this;
				const list = that.list;
				var driver = [];
				for (var i = 0; i < list.length; i++) {
					if (list[i].checked) {
						driver.push(list[i].id);
					}
				}
				that.coin.loading = true;
				that.$post('driverCoin', {
					type: that.coin.form.type,
					desc: that.coin.form.desc,
					driver: driver,
					amount: that.coin.form.amount
				}).then(res => {
					that.coin.show = false;
					that.$message.success("操作成功");
					setTimeout(function() {
						that.pageDriver(1);
					}, 1000);
				}).catch(e => {
					that.coin.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			orderDriver(name) {
				this.$router.push({
					name: "order_list_all",
					params: {
						query: {
							keytype: "name",
							keyword: name
						}
					}
				});
			},
			commentDriver(name) {
				this.$router.push({
					name: "order_comment",
					params: {
						query: {
							keytype: "driver",
							keyword: name
						}
					}
				});
			},
			amountDriver(driver) {
				this.dialog_amount.show = true;
				this.dialog_amount.driver = driver;
				this.dialog_amount.total = 0;
				this.dialog_amount.list = [];
				this.postAmountDriver();
			},
			pageAmountDriver(e) {
				this.dialog_amount.page = e;
				this.postAmountDriver();
			},
			postAmountDriver() {
				const that = this;
				that.dialog_amount.loading = true;
				that.$post('driverAmount', {
					driver: that.dialog_amount.driver,
					page: that.dialog_amount.page
				}).then(res => {
					setTimeout(function() {
						that.dialog_amount.loading = false;
						that.dialog_amount.total = res.data.total;
						that.dialog_amount.list = res.data.list;
					}, 500);
				}).catch(e => {
					that.dialog_amount.show = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			addDriver() {
				const that = this;
				that.info.show = true;
				that.info.loading = false;
				that.info.form = that.$options.data().info.form;
				if (that.$refs.driverInfoForm != undefined) {
					that.$refs.driverInfoForm.resetFields();
				}
			},
			editDriver(index) {
				const that = this;
				that.info.show = true;
				that.info.loading = false;
				that.$set(that.info, 'form', {
					mode: "edit",
					id: that.list[index].id,
					head: that.list[index].rhead,
					name: that.list[index].rname,
					phone: that.list[index].phone,
					cardid: that.list[index].cardid,
					carddate: that.list[index].cardtime,
					take: that.list[index].take,
					takes: that.list[index].takes,
					admin: that.list[index].admin
				});
				if (that.$refs.driverInfoForm != undefined) {
					that.$refs.driverInfoForm.resetFields();
				}
			},
			submitInfoDriver() {
				const that = this;
				that.$refs.driverInfoForm.validate((valid) => {
					if (valid) {
						that.info.loading = true;
						that.$post('driver', that.info.form).then(res => {
							that.info.show = false;
							that.$message.success("操作成功");
							setTimeout(function() {
								that.pageDriver(1);
							}, 1000);
						}).catch(e => {
							that.info.loading = false;
							that.$alert((e != undefined && e.message != undefined && e.message) ? e
								.message :
								"未知错误，请重试", '提示', {
									type: 'error',
									confirmButtonText: '确定'
								});
						});
					} else {
						return false;
					}
				});
			},
			delDriver(index, type) {
				const that = this;
				const ss = (type == 1) ? "停用" : "恢复";
				that.$msgbox({
					title: "提示",
					message: "确定要" + ss + "司机【" + that.list[index].rname + "】吗？",
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					beforeClose: (action, instance, done) => {
						if (action === 'confirm') {
							instance.confirmButtonLoading = true;
							instance.confirmButtonText = ss + "中...";
							that.$post('driverDel', {
								driver: that.list[index].id
							}).then(res => {
								done();
								that.$message.success("操作成功");
								setTimeout(function() {
									that.pageDriver(1);
								}, 1000);
								that.$nextTick(function() {
									instance.confirmButtonLoading = false;
									instance.confirmButtonText = '确定';
								});
							}).catch(e => {
								done();
								that.$nextTick(function() {
									instance.confirmButtonLoading = false;
									instance.confirmButtonText = '确定';
								});
								that.$alert((e != undefined && e.message != undefined && e.message) ? e
									.message :
									"未知错误，请重试", '提示', {
										type: 'error',
										confirmButtonText: '确定'
									});
							});
						} else {
							done();
						}
					}
				}).catch(e => {});
			},
			jobDriver(e, index) {
				const that = this;
				that.$post('driverJob', {
					driver: that.list[index].id,
					job: e
				}).then(res => {
					that.$message.success("操作成功");
				}).catch(e => {
					that.list[index].job = (e == 1) ? 0 : 1;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			coopeDriver(e, index) {
				const that = this;
				that.$post('driverCoope', {
					driver: that.list[index].id,
					coope: e
				}).then(res => {
					that.$message.success("操作成功");
				}).catch(e => {
					that.list[index].coope = (e == 1) ? 0 : 1;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			cropperImageDriver(res) {
				const that = this;
				const reader = new FileReader();
				const isImage = res.raw.type === 'image/jpeg' || res.raw.type === 'image/jpg' || res.raw.type ===
					'image/png'
				const isLt5M = res.size / 1024 / 1024 < 5;
				if (!isImage) {
					that.$message.error('头像格式错误，只能JPG/PNG格式');
					return;
				}
				if (!isLt5M) {
					that.$message.error('头像大小不能超过5MB');
					return;
				}
				reader.readAsDataURL(res.raw);
				reader.onload = function() {
					var img = new Image();
					img.src = reader.result;
					if (img.complete) { //如果存在浏览器缓存中
						if (img.width < 400 || img.height < 400) {
							that.$message.error('头像尺寸必须400*400以上');
							return;
						} else {
							that.$nextTick(() => {
								that.dialog_cropper.show = true;
								that.dialog_cropper.image = URL.createObjectURL(res.raw);
							});
						}
					} else {
						img.onload = function() {
							if (img.width < 400 || img.height < 400) {
								that.$message.error('头像尺寸必须400*400以上');
								return;
							} else {
								that.$nextTick(() => {
									that.dialog_cropper.show = true;
									that.dialog_cropper.image = URL.createObjectURL(res.raw);
								});
							}
						}
					}
				}
			},
			submitCropperImageDriver() {
				const that = this;
				that.$refs.cropper.getCropBlob((data) => {
					const file = new FileReader();
					file.readAsDataURL(data);
					file.onload = function() {
						that.dialog_cropper.show = false;
						that.info.form.head = file.result;
					}
					file.onerror = function() {
						that.$message.error("头像裁剪失败，请重试");
					}
				});
			},
			refreshDriver() {
				this.pageDriver(1);
			},
			pageDriver(e) {
				this.page = e;
				this.postDriver(this.query);
			},
			postDriver(query = {}) {
				const that = this;
				that.loading = true;
				that.$post('driver', {
					query: query,
					page: that.page
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.total = res.data.total;
						that.coin_disabled = true;
						res.data.list.map((item) => {
							item.checked = false;
							return item;
						});
						that.list = res.data.list;
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.driver .user {
		display: flex;
		align-items: center;
		padding: 10px;
		position: relative;
	}

	.driver .user .avatar {
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 0.375rem;
	}

	.driver .user .info {
		margin-left: 0.3125rem;
	}

	.driver .user .info .name {
		font-size: 0.875rem;
		font-weight: bold;
		color: #576b95
	}

	.driver .user .admin {
		width: 0.875rem;
		height: 0.875rem;
		margin-left: 0.125rem;
		margin-bottom: 0.125rem;
		vertical-align: middle;
	}

	.driver .user .phone {
		color: #999;
		font-size: 0.875rem;
	}

	.driver .user .take {
		position: absolute;
		top: -0.125rem;
		left: -0.125rem;
	}

	.driver .user .take .bg {
		border-left: 2.5rem solid lightseagreen;
		border-bottom: 2.5rem solid transparent;
	}

	.driver .user .take.o1 .bg {
		border-left: 2.5rem solid darkorange;
		border-bottom: 2.5rem solid transparent;
	}

	.driver .user .take .text {
		position: absolute;
		top: 0.3125rem;
		left: 0;
		color: white;
		font-weight: bold;
		text-align: center;
		font-size: 0.75rem;
		transform: scale(.8);
		transform: rotate(-45deg);
	}

	.driver .amount,
	.driver .order,
	.driver .dage,
	.driver .score,
	.driver .online,
	.driver .job,
	.driver .coope,
	.driver .operate {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.875rem;
	}

	.driver .amount .box,
	.driver .order .box,
	.driver .score .box {
		display: flex;
		align-items: baseline;
	}

	.driver .takes {
		text-align: center;
		font-size: 0.75rem;
	}

	.driver .takes span {
		color: red;
		font-weight: bold;
	}

	.driver .online .box .log {
		font-size: 0.75rem;
	}

	.dialog.del .quick {
		margin-top: 0.2rem;
	}

	.dialog.del .quick span {
		font-size: 0.8125rem;
		cursor: pointer;
		margin-right: 0.625rem;
	}

	.cropper-content .cropper {
		width: auto;
		height: 24rem;
	}
</style>
